import { ToastProps, Toast } from './Toast';

function ErrorToast({ children, className }: ToastProps) {
  return <Toast className={`alert-error ${className}`}>{children}</Toast>;
}

export default ErrorToast;
